"use client";

import React, { useState, useEffect } from "react";
import Link from "next/link";

export function Slide() {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    // Activar animaciones después de que el componente se monte
    const timer = setTimeout(() => {
      setIsLoaded(true);
    }, 100);

    return () => clearTimeout(timer);
  }, []);

  return (
    <section id="relume" className="relative min-h-svh flex items-center px-0 md:px-0 overflow-hidden">
      {/* Imagen de fondo con animación de zoom */}
      <div className="absolute inset-0 z-0">
        <div 
          className={`w-full h-full bg-cover bg-center bg-no-repeat ${
            isLoaded ? 'animate-zoom-slow' : 'scale-100'
          }`}
          style={{ 
            backgroundImage: 'url(/imagenes-web.jpg)',
            transformOrigin: 'center center'
          }}
        />
      </div>

      {/* Contenido con animación desde la derecha */}
      <div 
        className={`relative z-10 flex flex-col justify-center items-start max-w-lg w-full ml-8 md:ml-20 lg:ml-32 transition-all duration-1500 ease-out ${
          isLoaded 
            ? 'opacity-100 translate-x-0' 
            : 'opacity-0 translate-x-16'
        }`}
      >
        <div className="bg-black/30 backdrop-blur-sm rounded-lg p-6 md:p-8">
          <h1 
            className={`mb-4 text-2xl md:text-4xl lg:text-5xl font-bold text-white leading-tight transition-all duration-1500 ease-out delay-300 ${
              isLoaded 
                ? 'opacity-100 translate-x-0' 
                : 'opacity-0 translate-x-12'
            }`}
          >
            Descubre tu próximo vehículo con nosotros
          </h1>
          <p 
            className={`text-white text-xs md:text-sm mb-5 leading-relaxed transition-all duration-1500 ease-out delay-500 ${
              isLoaded 
                ? 'opacity-100 translate-x-0' 
                : 'opacity-0 translate-x-8'
            }`}
          >
            En Vehículos NDC, ofrecemos una amplia selección de automóviles nuevos de las mejores marcas como Ford, Geely, Kia, Mazda, Lincoln, JAC, Shineray, SWM y Forland. Explora nuestras opciones y encuentra el vehículo perfecto que se adapte a tus necesidades.
          </p>
          <Link 
            href="/vehiculos"
            className={`bg-white text-black font-semibold px-6 py-3 text-sm hover:bg-gray-100 transition-all duration-300 inline-block ${
              isLoaded 
                ? 'opacity-100 translate-x-0' 
                : 'opacity-0 translate-x-4'
            }`}
            style={{ 
              transitionDuration: '1500ms', 
              transitionDelay: '700ms',
              transitionTimingFunction: 'ease-out'
            }}
          >
            Descubre tu próximo vehículo
          </Link>
        </div>
      </div>
    </section>
  );
}
